<template>
  <div>
    <RegionalRoadmapOverview>
      <template #header="{ downloadPdf, isDownloadingPdf, displayRegion }">
        <div class="mb-6">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div>
              <h1 class="text-2xl font-extrabold text-gray-900 tracking-tight">
                {{ t("greeting", { name: currentUser.firstName || "" }) }} 👋
              </h1>
              <div class="text-lg font-bold text-gray-700 mt-1">
                {{ t("region_title", { name: currentUserRegion }) }}
              </div>
              <div class="text-sm text-gray-400 mt-1">{{ $d(new Date(), "fullDate") }}</div>
            </div>
            <div class="flex flex-col sm:flex-row gap-2">
              <GenericButton v-if="hasActiveChallenge" @click="$router.push('/admin/challenge/current-challenge')">
                🔥 {{ t("challenge") }}
              </GenericButton>
              <SecondaryButton @click="$router.push('/admin/analytics/general')">
                <ChartBarIcon class="h-4 w-4 mr-2" />
                {{ t("global_view") }}
              </SecondaryButton>
              <SecondaryButton v-if="displayRegion" :loading="isDownloadingPdf" @click="downloadPdf">
                <DownloadIcon v-if="!isDownloadingPdf" class="h-4 w-4 mr-2" />
                {{ t("download_brief") }}
              </SecondaryButton>
            </div>
          </div>
        </div>
      </template>
    </RegionalRoadmapOverview>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { SecondaryButton, GenericButton } from "@estaly/ui";
import { ChartBarIcon } from "@heroicons/vue/outline";
import { DownloadIcon } from "@heroicons/vue/outline";
import RegionalRoadmapOverview from "@/views/common/RegionalRoadmapOverview.vue";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    SecondaryButton,
    GenericButton,
    ChartBarIcon,
    DownloadIcon,
    RegionalRoadmapOverview,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    ...mapState("auth", ["currentUser"]),
    ...mapGetters("auth", ["currentUserRegion"]),
    ...mapGetters("challenge", ["hasActiveChallenge"]),
  },
};
</script>

<i18n src="./RegionalManagerHome.i18n.json"></i18n>
